
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CHECKOUT_CORE_FEATURE } from '../feature-name';
import {Address, facadeFactory, QueryState} from "@lm-nx-frontend/lm-inf-core";

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: CheckoutDeliveryAddressFacade,
      feature: CHECKOUT_CORE_FEATURE,
      methods: [
        'getDeliveryAddressState',
        'createAndSetAddress',
        'setDeliveryAddress',
        'clearCheckoutDeliveryAddress',
      ],
      // TODO:#deprecation-checkout - remove once we remove ngrx
      async: true,
    }),
})
export abstract class CheckoutDeliveryAddressFacade {
  /**
   * Returns the delivery address state
   */
  abstract getDeliveryAddressState(): Observable<
    QueryState<Address | undefined>
  >;
  /**
   * Creates and sets the delivery address using the provided address
   */
  abstract createAndSetAddress(address: Address): Observable<unknown>;
  /**
   * Sets the delivery address to the cart
   */
  abstract setDeliveryAddress(address: Address): Observable<unknown>;
  /**
   * Clears the delivery address set in the cart
   */
  abstract clearCheckoutDeliveryAddress(): Observable<unknown>;
}
